/* eslint-disable */
import React from "react";
import { createBrowserHistory } from "history";
import { Switch, Route } from "react-router";
import Root from "./Root";
import { DownloadFileRoot } from "./DownloadFileRoot";
import Export from "./Export";
import Report1 from "./reports/Report1";
import Report2 from "./reports/Report2";
import Report3 from "./reports/Report3";
import Report4 from "./reports/Report4";
import Report5 from "./reports/Report5";
import Report6 from "./reports/Report6";
import Report7 from "./reports/Report7";
import Report8 from "./reports/Report8";
import AquariumCropValue from "./reports/AquariumCropValue";
import Report9 from "./reports/Report9";
import Report10 from "./reports/Report10";
import Report11 from "./reports/Report11";
import Report12 from "./reports/Report12";
import Report13 from "./reports/Report13";
import Slide12 from "./reports/Slide12";
import Slide13 from "./reports/Slide13";
import Slide15 from "./reports/Slide15";
import Slide16 from "./reports/Slide16";
import Slide17 from "./reports/Slide17";
import Slide18 from "./reports/Slide18";
import Slide20 from "./reports/Slide20";
import Slide21 from "./reports/Slide21";
import Slide23 from "./reports/Slide23";
import Slide24 from "./reports/Slide24";
import Slide31 from "./reports/Slide31";
import Slide32 from "./reports/Slide32";
import Slide33 from "./reports/Slide33";
import Slide34 from "./reports/Slide34";
import Slide35 from "./reports/Slide35";
import Slide36 from "./reports/Slide36";

const ReportRouter: React.FC<{ isExportMode?: boolean }> = (props) => {
  const { isExportMode: exportMode } = props;
  const router = React.useMemo(() => {
    const slides = new Map<string, any>([
      ["slide1", () => <Report1 exportMode={exportMode} />],
      ["slide2", () => <Report2 exportMode={exportMode} />],
      ["slide3", () => <Report7 exportMode={exportMode} />],
      ["slide4", () => <Report8 exportMode={exportMode} />],
      ["slide7", () => <AquariumCropValue exportMode={exportMode} />],
      ["slide25", () => <Report5 exportMode={exportMode} />],
      ["slide5", () => <Report3 exportMode={exportMode} />],
      ["slide6", () => <Report4 exportMode={exportMode} />],
      ["slide26", () => <Report6 exportMode={exportMode} />],
      ["slide8", () => <Report9 exportMode={exportMode} />],
      ["slide9", () => <Report10 exportMode={exportMode} />],
      ["slide10", () => <Report11 exportMode={exportMode} />],
      ["slide11", () => <Report12 exportMode={exportMode} />],
      ["slide14", () => <Report13 exportMode={exportMode} />],
      ["slide12", () => <Slide12 exportMode={exportMode} />],
      ["slide13", () => <Slide13 exportMode={exportMode} />],
      ["slide15", () => <Slide15 exportMode={exportMode} />],
      ["slide16", () => <Slide16 exportMode={exportMode} />],
      ["slide17", () => <Slide17 exportMode={exportMode} />],
      ["slide18", () => <Slide18 exportMode={exportMode} />],
      ["slide20", () => <Slide20 exportMode={exportMode} />],
      ["slide21", () => <Slide21 exportMode={exportMode} />],
      ["slide23", () => <Slide23 exportMode={exportMode} />],
      ["slide24", () => <Slide24 exportMode={exportMode} />],
      ["slide31", () => <Slide31 exportMode={exportMode} />],
      ["slide32", () => <Slide32 exportMode={exportMode} />],
      ["slide33", () => <Slide33 exportMode={exportMode} />],
      ["slide34", () => <Slide34 exportMode={exportMode} />],
      ["slide35", () => <Slide35 exportMode={exportMode} />],
      ["slide36", () => <Slide36 exportMode={exportMode} />],
    ]);
    const Router = () => {
      return (
        <Switch>
          <Route path="/slides/slide-36" component={slides.get("slide36")!} />
          <Route path="/slides/slide-35" component={slides.get("slide35")!} />
          <Route path="/slides/slide-34" component={slides.get("slide34")!} />
          <Route path="/slides/slide-33" component={slides.get("slide33")!} />
          <Route path="/slides/slide-32" component={slides.get("slide32")!} />
          <Route path="/slides/slide-31" component={slides.get("slide31")!} />
          <Route path="/slides/slide-24-ape" component={slides.get("slide24")!} />
          <Route path="/slides/slide-24" component={slides.get("slide24")!} />
          <Route path="/slides/slide-23" component={slides.get("slide23")!} />
          <Route path="/slides/slide-21" component={slides.get("slide21")!} />
          <Route path="/slides/slide-20" component={slides.get("slide20")!} />
          <Route path="/slides/slide-18" component={slides.get("slide18")!} />
          <Route path="/slides/slide-17" component={slides.get("slide17")!} />
          <Route path="/slides/slide-16" component={slides.get("slide16")!} />
          <Route path="/slides/slide-15" component={slides.get("slide15")!} />
          <Route path="/slides/slide-13" component={slides.get("slide13")!} />
          <Route path="/slides/slide-12" component={slides.get("slide12")!} />
          <Route path="/slides/stocks" component={slides.get("slide14")!} />
          <Route path="/slides/ap-annual-production-ape" component={slides.get("slide11")!} />
          <Route path="/slides/ap-annual-production" component={slides.get("slide11")!} />
          <Route path="/slides/ap-annual-area-ape" component={slides.get("slide10")!} />
          <Route path="/slides/ap-annual-area" component={slides.get("slide10")!} />
          <Route path="/slides/annual-crop-production-ape" component={slides.get("slide9")!} />
          <Route path="/slides/annual-crop-production" component={slides.get("slide9")!} />
          <Route path="/slides/annual-crop-area-ape" component={slides.get("slide8")!} />
          <Route path="/slides/annual-crop-area" component={slides.get("slide8")!} />
          <Route path="/slides/aquarium-crop-value" component={slides.get("slide7")!} />
          <Route path="/slides/aquarium-production-ape" component={slides.get("slide4")!} />
          <Route path="/slides/aquarium-production" component={slides.get("slide4")!} />
          <Route path="/slides/aquarium-area-ape" component={slides.get("slide3")!} />
          <Route path="/slides/aquarium-area" component={slides.get("slide3")!} />
          <Route path="/slides/lead-countries-major-crops-population-forecast" component={slides.get("slide26")!} />
          <Route path="/slides/lead-countries-major-crops-population" component={slides.get("slide25")!} />
          <Route path="/slides/lead-countries-major-crops-forecast-ape" component={slides.get("slide6")!} />
          <Route path="/slides/lead-countries-major-crops-forecast" component={slides.get("slide6")!} />
          <Route path="/slides/world-overview-major-crops-forecast-ape" component={slides.get("slide5")!} />
          <Route path="/slides/world-overview-major-crops-forecast" component={slides.get("slide5")!} />
          <Route path="/slides/lead-countries-major-crops-ape" component={slides.get("slide2")!} />
          <Route path="/slides/lead-countries-major-crops" component={slides.get("slide2")!} />
          <Route path="/slides/world-overview-major-crops-ape" component={slides.get("slide1")!} />
          <Route path="/slides/world-overview-major-crops" component={slides.get("slide1")!} />
        </Switch>
      );
    };
    return <Router />;
  }, [exportMode]);
  return exportMode ? <Export router={router} /> : <Root router={router} />;
};

const ReportGlobalRouter: React.FC = (props) => {
  const ExportRouter = React.useMemo(() => () => <ReportRouter isExportMode />, []);
  return (
    <Switch>
      <Route path="/slides/download/:fileKey" component={DownloadFileRoot} />
      <Route exact path="/slides/:reportId/export" component={ExportRouter} />
      <Route path="/slides/:reportId" component={ReportRouter} />
    </Switch>
  );
};

export default ReportGlobalRouter;
